import { render, staticRenderFns } from "./EditorAttachFile.vue?vue&type=template&id=1058dc0a&scoped=true&"
import script from "./EditorAttachFile.vue?vue&type=script&lang=js&"
export * from "./EditorAttachFile.vue?vue&type=script&lang=js&"
import style0 from "./EditorAttachFile.vue?vue&type=style&index=0&id=1058dc0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1058dc0a",
  null
  
)

export default component.exports